import React from "react";
import "./MineralPermitPage.css";

const MineralPermitPage = ({ productData }) => {
    if (!productData) return null;

    // Take the first 3 steps dynamically
    const points = productData.points?.slice(0, 3) || [];

    // Split workDescription into paragraphs
    const paragraphs = productData.workDescription
        ? productData.workDescription.split(/\r?\n\r?\n/)
        : [];

    return (
        <div className="mineral-permit-page">
            <div className="mineral-permit-container">
                <div className="mineral-permit-section-content">
                    {/* Left Content */}
                    <div className="mineral-permit-left-content">
                        <header className="mineral-permit-page-header">
                            <h1>{productData.workTitle || "Online Mineral ePermit System"}</h1>
                        </header>

                        {/* Render paragraphs */}
                        {paragraphs.length > 0 &&
                            paragraphs.map((para, index) => (
                                <p key={index} className="mineral-permit-work-description">
                                    {para}
                                </p>
                            ))}
                    </div>

                    {/* Right Steps */}
                    <div className="mineral-permit-right-steps">
                        {points.map((point, index) => (
                            <div key={index} className="mineral-permit-step-card">
                                <div className="mineral-permit-step-number">
                                    {(index + 1).toString().padStart(2, "0")}
                                </div>
                                <div className="mineral-permit-step-content">
                                    <h3>{point.title || `Step ${index + 1}`}</h3>
                                    <p>{point.description || ""}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MineralPermitPage;